import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore } from '@core/ngrx-legacy';
import {
  HiringResource,
  HiringResourceEntity,
  HiringResourceScope,
} from '@core/tellent-assign-members-to-jobs-types';

const idSelector = ({ guid }: HiringResource) => guid;
const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<HiringResourceEntity>()('HiringResources', {
    idSelector,
    customActions: adapter => ({
      fetchCollection: (state, payload: { scope: HiringResourceScope; appGuid: string }) =>
        adapter.markAsPending(state, { scope: payload.scope, entities: [] }),
    }),
  });

const HiringResourcesActions: Pick<
  typeof actions,
  'fetchCollection' | 'fetchCollectionSuccess' | 'fetchCollectionFailed'
> = actions;

const jobs = createSelector(
  selectors.entities({ scope: 'jobs' }),
  entities => <HiringResource[]>entities,
);

const talentPools = createSelector(
  selectors.entities({ scope: 'talentPools' }),
  entities => <HiringResource[]>entities,
);

const HiringResourcesSelectors = {
  ...selectors,
  jobs,
  talentPools,
};

export {
  HiringResourcesActions,
  HiringResourcesSelectors,
  reducer as HiringResourcesReducer,
  namespace as HiringResourcesNamespace,
};
